import React, { useEffect, useRef, useState } from "react";
import ImgArt from "../AreaOrdiniComponenti/OrdineComponenti/ImgArt";

export default function MiniaturaMagazzino({ articolo }) {
  const ref=useRef(null);
  const [visibile,setVisibile]=useState(false);
  useEffect(()=>{
    if (!window.IntersectionObserver) {setVisibile(true);return undefined;}
    const observer=new IntersectionObserver(entries=>{
      if(entries.some(e=>e.isIntersecting)){setVisibile(true);observer.disconnect();}
    },{rootMargin:"100px"});
    observer.observe(ref.current);
    return ()=>observer.disconnect();
  },[]);
  return <div ref={ref} className="mag-miniatura">
    {visibile && articolo && <ImgArt prodIDps={articolo.prodIDps} imgIDps={articolo.imgIDps}
      codVS={articolo.codice_vs} fonte={articolo.fonte} size="small_default" zoomable={false}
      imageClassName="mag-miniatura-img" alt={articolo.descrizione || articolo.codice_vs || "Articolo"}/>}
  </div>;
}
